<template>
	<div id='myApp' class='gPageBorder' v-loading='loading'>

		<el-dialog class='gDia' :title="$t('terminal.list.import_btn')" v-model="ipDialog">
			<el-form class='gForm' label-position="right" ref="" :rules='rules' label-width="20.5%">
				<el-form-item :label="$t('app_file')" prop='name'>
					<el-button type='success' @click="downm">{{$t('app_downtpl')}}</el-button>
				</el-form-item>
				<el-form-item :label="$t('terminal.list.import_btn')" prop='url'>
					<el-upload class="upload-demo" name='fileUpload' :action="fileUploadUrl" :before-upload="srcBefore"
						:on-success="srcSuccess" :file-list="srcList">
						<el-button size="" type="primary">{{$t('app_clickUpdate')}}</el-button>
						<div slot="tip" style='' class="el-upload__tip">{{$t('terminal.list.excel_tips')}}&nbsp;</div>

					</el-upload>
				</el-form-item>

			</el-form>
		</el-dialog>

		<el-row>
			<el-col :span='8'>
				<div class='gSgLeftBtn'>
					<el-button type="primary" @click="add">{{$t('terminal.list.add_btn')}}</el-button>
					<el-button type="primary" @click="importDv">{{$t('terminal.list.import_btn')}}</el-button>
					<el-button type="danger" :disabled="multipleSelection.length == 0"
						@click='bcdel'>{{$t('app_mulDel')}}</el-button>
				</div>
			</el-col>


			<el-col :span='4'>
				<div class='gCtrl'>
					<MechanismSelector style='width:100%;' :data="mechanismData"></MechanismSelector>
				</div>
			</el-col>

			<el-col :span='4'>

				<div class='gCtrl'>
					<el-select v-model="statusVl" @change="stChange" placeholder="油机状态">
						<el-option v-for="item in sstatusAr" :key="item.vl" :label="item.lb" :value="item.vl">
						</el-option>
					</el-select>
				</div>
			</el-col>
			<el-col :offset="0" :span='4'>
				<div class='gSideCtrl'><el-input :placeholder="$t('app_name') + '&' + $t('app_number') " icon='search'
						:on-icon-click='query' @keyup.enter.native='query' v-model='queryKey'></el-input></div>
			</el-col>
			<el-col :span='4'>
				<div class='gCtrl'>
					<el-select v-model="activeStatus" @change="stChange" :placeholder="$t('lin_global.dest_status')">
						<el-option v-for="item in dest_list" :key="item.vl" :label="item.lb" :value="item.vl">
						</el-option>
					</el-select>
				</div>
			</el-col>
		</el-row>



		<div>
			<el-table class='tbPoint gTopMg' @row-click='cellClick' ref="multipleTable" :data="tableData"
				@sort-change="sortChange" border tooltip-effect="dark" style="width: 100%"
				@selection-change="handleSelectionChange">
				<el-table-column align=center type="selection" width="55">
				</el-table-column>
				<el-table-column align=center sortable="custom" prop='terminalName' :label="$t('app_deviceName')"
					width="">
				</el-table-column>
				<el-table-column align=center prop='terminalNo' sortable="custom" :label="$t('app_deviceNo')" width="">
				</el-table-column>
				<el-table-column align=center prop='terminalStatus' :formatter="mkDvSt" :label="$t('app_status')"
					width="">
				</el-table-column>
				<!-- <el-table-column
          align=center
  	      prop="appInstallType"
  	      :label="$t('app_insType')"
  	      width='100'>
          <template slot-scope='scope'>
            <el-label>{{setInstallType(scope.row.appInstallType)}}</el-label>
          </template>
  	    </el-table-column> -->
				<el-table-column align=center prop='modelName' :label="$t('app_model')" width="">
				</el-table-column>
				<el-table-column align=center prop='typeName' :label="$t('app_type')" width="">
				</el-table-column>
				<el-table-column align=center prop='mechName' :label="$t('app_distributor')" width="">
				</el-table-column>
				<el-table-column align=center prop='activeStatus' :label="$t('lin_global.dest_status')" width="">
				</el-table-column>
				<el-table-column sortable="custom" align=center prop='updateTime' width='106'
					:label="$t('terminal.list.ztgxsj')">
				</el-table-column>
				<el-table-column prop="operate" align=center :label="$t('app_operate')" width='86'>
					<template slot-scope='scope'>
						<!-- <el-button @click='edit(scope.row)' type=text>编辑</el-button> -->
						<!-- <el-button @click='del(scope.row.id)' type=text>删除</el-button> -->
						<!-- <el-button @click='undercarriage(scope.row)' type=text>{{$t('app_offShelf')}}</el-button> -->

						<el-tooltip class="item" effect="dark" :content="$t('app_del')" placement="top">
							<el-button type='text' @click='del(scope.row.id)'><i class="fa fa-trash-o"
									style="color:#FF4949"></i></el-button>
						</el-tooltip>

						<!-- <el-tooltip class="item" effect="dark" :content="$t('app_push')" placement="top">
              <el-button type='text' @click='bindOperate(scope.row)'><i class="fa fa-upload" style=""></i></el-button>
            </el-tooltip> -->

						<!-- <el-tooltip class="item" effect="dark" :content="$t('app_offShelf')" placement="top">
              <el-button type='text' @click='undercarriage(scope.row)'><i class="fa fa-arrow-circle-o-down" style=""></i></el-button>
            </el-tooltip> -->

					</template>
				</el-table-column>
			</el-table>
		</div>

		<div class="gPgDiv">

			<el-pagination class='gPg' @current-change="pageSelect" @size-change="pageSized" :current-page="page"
				:page-sizes='$gRows' :page-size="row" layout="total, sizes, prev, pager, next, jumper" :total="total">
			</el-pagination>
		</div>
	</div>
</template>

<style>
	html body {
		background: white;
		margin: 0;
		padding: 0
	}

	#myApp {
		background: none;
		overflow: hidden;
	}

	#maAdd {
		overflow: hidden;
		margin-top: 20px;
	}

	#maAdd button {}

	#maTable {
		margin-top: 20px;
		margin-left: 0px;
		margin-right: 0px;
	}

	#maPage {
		overflow: hidden;
		background: none;
		margin-top: 10px;
	}

	#maPage div {
		float: right;
		margin-right: 0px;
	}
</style>

<script>
	import MechanismSelector from '@/components/global/mechanism_selector.vue'
	// import {CodeToText, regionDataPlus} from 'element-china-area-data'
	export default {
		data() {
			return {
				orderName: '',
				orderType: '',
				sNum: 0,
				// options: regionDataPlus,
				ssq: [""],
				srcList: [],
				status: [{
						label: '全部状态',
						value: ''
					},
					{
						label: '正常',
						value: '1'
					},
					{
						label: '异常',
						value: '2'
					}
				],
				sstatus: {
					'0': this.$t('app_new'),
					'1': this.$t('app_enable')
				},
				sstatusAr: [{
						vl: '',
						lb: this.$t('app_all')
					},
					{
						vl: '0',
						lb: this.$t('app_new')
					},
					{
						vl: '1',
						lb: this.$t('app_enable')
					}
				],
				dest_list: [
					{
						vl: '0',
						lb: this.$t('lin_global.normal')
					},
					{
						vl: '1',
						lb: this.$t('app_selfDestroy')
					}
				],
				statusVl: '',
				activeStatus:"",
				ipDialog: false,
				mechanismId: '',
				loading: 0,
				mechanismData: '',
				queryKey: '',
				appType: '',
				appTypes: [],
				tableData: [],
				multipleSelection: [],
				total: 0,
				page: 1,
				dialogTopMgVisible: 0,
				dialogConfig: {
					tip: '',
					data: '',
					type: ''
				},
				selectAll: {}
			}
		},
		components: {
			MechanismSelector
		},
		computed: {
			fileUploadUrl() {
				// return this.$fileUpImgloadUrl
				return this.$addrPre + '/scanner/importTers.do' + "?language=" + localStorage.system_lang + '&token=' +
					localStorage.user
			}
		},
		methods: {
			sortChange(vl) {
				switch (vl.prop) {
					case 'terminalName':
						this.orderName = '1'
						break
					case 'terminalNo':
						this.orderName = '2'
						break
					case 'updateTime':
						this.orderName = '3'
						break
				}
				this.orderType = vl.order == 'descending' ? 'desc' : 'asc'
				this.getList()
			},
			srcBefore(file) {
				// console.log(file)
				var name = file.name
				if (name) { //  === 'part0.zip'
					window[this.$route.path] = 1
					return true
				} else {
					this.$message(this.$t('app_fileNameOnly') + 'part0.zip')
					return false
				}
			},
			srcSuccess(res, file) {
				window[this.$route.path] = ''
				console.log(res)
				if (res.status === 200) {
					this.ipDialog = false
					this.$message.success(res.message)
					this.srcList = []
				} else {
					this.srcList = []
					this.$message.error(res.message)
				}
			},
			downm() {
				window.open(this.$host + '/tms-server-web/model/terminal_scanner.xlsx')
			},
			importDv() {
				this.ipDialog = true
			},
			stChange() {
				this.getList()
			},
			mkDvSt(row) {
				return this.sstatus[row.terminalStatus]
			},
			makeArea(row) {
				// if (row.address) {
				//   var arr = row.address.split(',')
				//   console.log(arr)
				//   var p = arr[0]? CodeToText[arr[0]] : ''
				//   var c = arr[1]? CodeToText[arr[1]] : ''
				//   var a = arr[2]? CodeToText[arr[2]] : ''
				//   return p+c+a
				// }

			},
			handleChange() {
				this.getList()
			},
			setAddr(row) {
				// var p = row.province? CodeToText[row.province] : ''
				// var c = row.city? CodeToText[row.city] : ''
				// var a = row.area? CodeToText[row.area] : ''
				// return p+c+a + row.manufacturerAddress
			},
			setInstallType(type) {
				return this.$installType[type]
			},
			query() {
				this.getList()
			},
			reset() {
				this.queryKey = ''
				this.appType = ''
				this.getList()
			},
			selectChange(vl) {
				this.getList()
			},
			cellClick(row, ev, col) {
				if (col.label && col.label !== this.$t('app_operate')) {
					// console.log(row)
					// this.$setWObj('editAppConfig', {type: 2, data: row})
					// /appSlot/view
					//this.$router.push({name: this.$t('menu.appManageSub.viewApp')})

					// this.edit(row)
					this.detail(row)
				}
			},
			dateFormat(row, column) {
				// var date = row[column.property]
				// if (date === undefined) {
				//   return ''
				// }
				// return mm(date).format('YYYY-MM-DD HH:mm:ss')
			},
			pageSelect(index) {
				this.page = index
				this.getList()
			},
			pageSized(val) {
				this.$gRow = val
				this.getList()
			},
			toggleSelection(rows) {
				if (rows) {
					rows.forEach(row => {
						this.$refs.multipleTable.toggleRowSelection(row)
					})
				} else {
					this.$refs.multipleTable.clearSelection()
				}
			},
			bcdel() {
				this.$showConfirm(this.$t('app_tip'), "确定要删除这些数据？", this.$t('app_sure'), this.$t('app_cancel'), 'warning',
					() => {
						var ids = ''
						this.multipleSelection.forEach((vl) => {
							ids += vl.id + ','
						})
						ids = ids.substring(0, ids.length - 1)
						if (!ids) {
							this.$message(this.$t('app_chooseOneMust'))
							return
						}
						this.delRqs(ids)
					}, '')

			},
			handleSelectionChange(val) {
				this.sNum = val.length
				this.multipleSelection = val

			},
			del(mid) {
				this.$showConfirm(this.$t('app_tip'), "确定删除此数据？", this.$t('app_sure'), this.$t('app_cancel'), 'warning',
				() => {
						this.delRqs(mid)
					}, '')
			},
			delRqs(mid) {
				this.loading = 1
				this.$delNonieDv(mid, (res) => {
					if (res.status === 200) {
						// this.$message.success(res.message)
						this.getList()
					} else {
						this.$message.error(res.message)
					}
					this.loading = 0
				}, () => {
					// error
					this.loading = 0
				})
			},
			detail(row) {
				// this.$setTmp('mcedit',{data: row, type: 1})
				this.$setWObj('ndObj', {
					data: row.id
				})
				this.$router.push({
					path: '/non-it-eq/device/detail'
				})
			},
			add() {
				// /appSlot/distribute-add
				//this.$router.push({name: this.$t('menu.appManageSub.custom')})
				// this.$setTmp('mcedit', {type: 0, data: {}})
				this.$router.push({
					path: '/non-it-eq/device/add'
				})
			},
			bindOperate(obj) {
				//console.log(obj)
				//return
				//this.$setWObj('appBindInfo', {data: obj, type: 1})
				//this.$router.push({name: this.$t('menu.appManageSub.customPush')})
				this.$setWObj('pushList', {
					data: obj,
					type: '1'
				})
				this.$router.push({
					path: '/appslot/distribute-push'
				})
			},
			selected(rows) {
				/* rows.forEach(row => {
				  console.log('e', row)
				  this.$refs.multipleTable.toggleRowSelection(row);
				}) */
			},
			getList() {
				this.loading = 1
				var no = this.queryKey ? this.queryKey : ''
				var mcid = this.mechanismId ? this.mechanismId : ''
				var status = this.statusVl
				var activeStatus = this.activeStatus
				
				this.$getNonItDv(this.page, this.$gRow, mcid, no, status,activeStatus, this.orderName, this.orderType, '', '', (
				res) => {
					console.log(res)
					this.loading = 0
					if (res.status === 200) {
						this.total = res.total
						this.tableData = res.data
						// console.log('tbd', res.data)
					} else {
						this.$message.error(res.message)
					}
				}, () => {
					this.loading = 0
					// error
				})

			}
		},
		mounted() {

			var mVl = '' //默认选中
			var _this = this
			this.mechanismData = {
				value: mVl,
				placeholder: this.$t('lin_global.place_areaid'),
				callback(value) {
					_this.mechanismId = value
					_this.getList()
				}
			}



			this.getList()

		}
	}
</script>


// WEBPACK FOOTER //
// list.vue?5d9da036